<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperMaterialsAndEquipmentsTransfer',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'MaterialsAndEquipmentsTransferModule',
    };
  },
};
</script>
